import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import ImagesSelector from "@/lib/components/form/file/auto-storing/ImageSelector.vue";
import SubMenu from "@/lib/components/layout/menu/SubMenu.vue";
import {computed, PropType} from "vue";
import JsonSelector from "@/lib/components/form/file/auto-storing/JsonSelector.vue";
import {SSegmentedImage} from "@/store/Spatial2DAnnotation/model/SSegmentedImage";
import {
  SegmentedImagesStoreManager
} from "@/store/Spatial2DAnnotation/manager/SegmentedImagesStoreManager";
import ColoredSelectionGroup from "@/lib/components/form/selection/ColoredSelectionGroup.vue";
import {
  SegmentationTargetTypeParamsStoreManager
} from "@/store/Spatial2DAnnotation/manager/SegmentationTargetTypeParamsStoreManager";
import {AbstractSubStoreManager} from "@/lib/store/manager/abstract/AbstractSubStoreManager";
import ButtonGroup from "@/lib/components/UI/ButtonGroup.vue";
import {ButtonData} from "@/lib/components/UI/type/ButtonData";

// ------------------------------
//  Base
// ------------------------------


export default /*#__PURE__*/_defineComponent({
  name: 'Segmentation2DLeftMenu',
  props: {
  segmentedImages: Array as PropType<SSegmentedImage[]>,
},
  setup(__props) {




// ------------------------------
//  Annotations menu
// ------------------------------

const selectedOptionsIds = computed(() => {
  return SegmentationTargetTypeParamsStoreManager.store.selected;
})

const coloredSelectionGroupOptions = computed(() => {
  return SegmentationTargetTypeParamsStoreManager.store.entries;
})

let hasNotPreviousSegmentedImage = computed(() => {
  return !SegmentedImagesStoreManager.store.hasPreviousSegmentedImageTargets;
})

const onGroupSelectSelection = (instanceId: string) =>
{
  SegmentationTargetTypeParamsStoreManager.store.setIsSelected({instanceId: instanceId, isSelected: true});
}

const onGroupSelectAddition = ({value, colorCode}: {value: string, colorCode: string}) =>
{
  SegmentationTargetTypeParamsStoreManager.add({
    instanceId: AbstractSubStoreManager.createInstanceId(),
    isSelected: false,
    value: value,
    colorCode: colorCode,
  });
}

const annotationToolsButtons: ButtonData[] = [
  {
    id: 'copy-previous-annotations',
    text: 'Copy previous image\'s annotations',
    isDisabled: hasNotPreviousSegmentedImage
  }
];

const copyPreviousAnnotations = () =>
{
  SegmentedImagesStoreManager.copyPreviousImageAnnotations();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SubMenu, {
      title: "Load",
      icon: require('@/lib/assets/img/icons/chevron-right.svg')
    }, {
      default: _withCtx(() => [
        _createVNode(ImagesSelector, {
          text: "Load pictures",
          icon: require('@/lib/assets/img/icons/images.svg'),
          is_multiple: true,
          manager_class: _unref(SegmentedImagesStoreManager),
          manager_mutator: "addEmpty"
        }, null, 8, ["icon", "manager_class"]),
        _hoisted_1,
        _withDirectives(_createVNode(JsonSelector, {
          text: "Load segmentation data",
          icon: require('@/assets/img/icons/segmentation.svg'),
          is_multiple: true,
          manager_class: _unref(SegmentedImagesStoreManager),
          manager_mutator: "addFromFile",
          empty_store_before_load: false
        }, null, 8, ["icon", "manager_class"]), [
          [_vShow, __props.segmentedImages && __props.segmentedImages.length]
        ])
      ]),
      _: 1
    }, 8, ["icon"]),
    _withDirectives(_createVNode(SubMenu, {
      title: "Annotation tools",
      icon: require('@/lib/assets/img/icons/chevron-right.svg')
    }, {
      default: _withCtx(() => [
        _createVNode(ColoredSelectionGroup, {
          options: _unref(coloredSelectionGroupOptions),
          selectedOptionsIds: _unref(selectedOptionsIds).map(entry => entry.instanceId),
          "can-options-be-deleted": false,
          "can-add-new-options": true,
          "add-new-option-placeholder": "New target name",
          optionIdHolder: "instanceId",
          onSelect: onGroupSelectSelection,
          onAddColoredOption: onGroupSelectAddition
        }, null, 8, ["options", "selectedOptionsIds"]),
        _hoisted_2,
        _createVNode(ButtonGroup, {
          buttons: annotationToolsButtons,
          onClick: copyPreviousAnnotations
        })
      ]),
      _: 1
    }, 8, ["icon"]), [
      [_vShow, __props.segmentedImages && __props.segmentedImages.length && _unref(SegmentedImagesStoreManager).store.currentSegmentedImage]
    ])
  ], 64))
}
}

})